<template>
  <div>
  <div v-if="logistic_list.length>0" class="order-trace">
    <ul class="date-line">
      <li v-for="(item, index) in logistic_list" :key="index" class="date-item">{{item.update_time}}</li>
    </ul>
    <Timeline>
        <TimelineItem style="height: 100px;" v-for="(item, index) in logistic_list" :key="index">
            <p class="time"></p>
            <p class="content"><pre 
                  v-html="item.description"
                ></pre></p>
        </TimelineItem>
    </Timeline>
  </div>
  <Empty :load="traceLoad"></Empty>
  </div>
</template>
<script>
import conf from "../../conf";
import RequestUtils from "../../../../utils/RequestUtils";
const { formatDateTime } = require("../../../../utils/ChatUtils");
import Empty from "../empty.vue";

export default {
  name: "faces",
  components: {
    Empty
  },
  data() {
    return {
      logistic_list: [],
      traceLoad: 1
    };
  },
  props: ["orderId"],
  methods: {
    getTrace () {
      let self = this;
      this.logistic_list = [];
      this.traceLoad = 2;
      let param = new FormData();
      param.set("store_id", this.$store.state.shopee.currentStore.id);
      param.set("order_sn", this.orderId);
      RequestUtils.request(conf.getTrace(), param).then(json => {
        let logistic_detail_info_list = json.tracking_info;
        logistic_detail_info_list = logistic_detail_info_list.map(function (elem) {
          elem.update_time = formatDateTime(new Date(elem.update_time*1000)).substr();
          return elem;
        });
        this.logistic_list = logistic_detail_info_list;
        self.traceLoad = this.logistic_list.length > 0 ? 3 : 1;
      })
    }
  },
  watch: {
    orderId () {
      console.log(this.orderId);
      this.getTrace();
    }
  }
};
</script>

<style scoped lang="scss">

.order-trace {
  display: flex;
  padding-left: 10rem;
  height: 800px;
  overflow: scroll;

  .date-line {
    list-style: none;
    margin-right: 1rem;

    .date-item {
      height: 100px;
      width: 111px;
    }
  }
}
</style>
